import React from 'react';
import { Play } from 'lucide-react';
import { isVideoUrl } from '../utils/mediaUtils';

interface MediaThumbnailProps {
  src: string;
  alt?: string;
  className?: string;
  /** If true, plays video inline on hover (for cards). Default false. */
  autoPreview?: boolean;
}

export const MediaThumbnail: React.FC<MediaThumbnailProps> = ({
  src,
  alt = '',
  className = 'w-full h-full object-cover',
  autoPreview = false,
}) => {
  if (isVideoUrl(src)) {
    return (
      <div className="relative w-full h-full">
        <video
          src={src}
          className={className}
          muted
          playsInline
          preload="metadata"
          // Load first frame as thumbnail
          onLoadedData={(e) => {
            const video = e.currentTarget;
            video.currentTime = 0.1;
          }}
        />
        {/* Play icon overlay */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="w-10 h-10 rounded-full bg-black/50 flex items-center justify-center">
            <Play className="w-5 h-5 text-white fill-white ml-0.5" />
          </div>
        </div>
      </div>
    );
  }

  return <img src={src} alt={alt} className={className} loading="lazy" />;
};
